import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { JobApplicationIntro, JobApplicationForm, JobApplicationSuccess, TrackApplication } from './pages';
import { Footer } from './components/Footer';

function App() {
  return (
    <main className="App">
      <div className="brand-watermark" aria-hidden="true">
        <img src="/images/logo.png" alt="" />
      </div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<JobApplicationIntro />} />
          <Route path="/apply" element={<JobApplicationForm />} />
          <Route path="/apply/success" element={<JobApplicationSuccess />} />
          <Route path="/track/:referenceNumber" element={<TrackApplication />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </main>
  );
}

export default App;
